import { render } from "./LessonCatsTopic2.vue?vue&type=template&id=418b29fd"
import script from "./LessonCatsTopic2.vue?vue&type=script&lang=js"
export * from "./LessonCatsTopic2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__